export default {"src":"/_next/static/media/profile.2eb96d68.svg","height":400,"width":240,"blurWidth":0,"blurHeight":0};